var $80c256804424a123$exports = {};
$80c256804424a123$exports = {
    "(optional)": `(opcijsko)`,
    "(required)": `(obvezno)`
};


export {$80c256804424a123$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
